export const getArrayOfObjectsFormattedValue = (value: Record<string, any>[]): string => {
  return value.map(item => item.name).join(', ');
}
